import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Navbar, Nav, Dropdown } from 'react-bootstrap';
import { Route, Routes, useNavigate } from 'react-router-dom';

function SettingsPage() {
  const [headerColor, setHeaderColor] = useState('#3880ff');
  const [fontColor, setFontColor] = useState('light');
  const [logoUrl, setLogoUrl] = useState('');
  const [financialYearStart, setFinancialYearStart] = useState('');
  const [financialYearEnd, setFinancialYearEnd] = useState('');
  const navigate = useNavigate();

  const handleStaffPricesClick = () => {
    navigate('/staff-prices');
  };



  useEffect(() => {
    // const loadSettings = async () => {
    //   try {
    //     const response = await fetch('https://marzdev.yourcrm.co.za/api/get_settings');

    //     if (!response.ok) {
    //       console.error(`HTTP error! Status: ${response.status}`);
    //       alert(`Failed to fetch settings: ${response.statusText}`);
    //       return;
    //     }

    //     const settings = await response.json(); // Parse the JSON data

    //     settings.forEach(setting => {
    //       if (setting.SettingName === 'headerColor') setHeaderColor(setting.SettingValue);
    //       if (setting.SettingName === 'fontColor') setFontColor(setting.SettingValue);
    //       if (setting.SettingName === 'logoUrl') setLogoUrl(setting.SettingValue);
    //       if (setting.SettingName === 'financialYearStart') setFinancialYearStart(setting.SettingValue);
    //       if (setting.SettingName === 'financialYearEnd') setFinancialYearEnd(setting.SettingValue);
    //     });

    //     console.log('Response:', settings);

    //   } catch (error) {
    //     console.error('Error fetching data:', error);
    //     alert('An error occurred while fetching settings data. Please try again later.');
    //   }
    // };
    // loadSettings();
  }, []);


  const handleHeaderColorChange = (e) => {
    setHeaderColor(e.target.value);
  };

  const handleFontColorChange = (e) => {
    setFontColor(e.target.value);
  };

  const handleLogoUrlChange = (e) => {
    setLogoUrl(e.target.value);
  };


  const handleFinancialYearStartChange = (e) => {
    setFinancialYearStart(e.target.value);
  };

  const handleFinancialYearEndChange = (e) => {
    setFinancialYearEnd(e.target.value);
  };




  const saveSettings = async () => {
    try {
      const settingsToSave = [
        { SettingName: 'headerColor', SettingValue: headerColor },
        { SettingName: 'fontColor', SettingValue: fontColor },
        { SettingName: 'logoUrl', SettingValue: logoUrl },
        { SettingName: 'financialYearStart', SettingValue: financialYearStart },
        { SettingName: 'financialYearEnd', SettingValue: financialYearEnd }
      ];

      for (const setting of settingsToSave) {
        const response = await fetch('https://marzdev.yourcrm.co.za/api/save_settings', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(setting)
        });

        if (!response.ok) {
          const errorMessage = await response.text();
          console.error(`Failed to save ${setting.SettingName}:`, errorMessage);
          alert(`Failed to save ${setting.SettingName}`);
          return; // Stop further attempts if any setting fails
        }
      }

      console.log('All settings saved successfully');
      alert('All settings saved successfully');

    } catch (error) {
      console.error('An unexpected error occurred:', error);
      alert('An unexpected error occurred while saving settings');
    }
  };


  const buttonStyle = {
    backgroundColor: headerColor, // Adjust for light/dark theme
    color: fontColor === 'light' ? '#000000' : '#ffffff', // Button text color
    borderColor: headerColor, // Button border color
  };



  return (
    <div>

      <div className="container mt-4">
        <div className="card">
          <div className="card-body">
            <div className="form-group">
              <label htmlFor="headerColorSelect">Select Header Background Colour</label>
              <select
                id="headerColorSelect"
                className="form-control"
                value={headerColor}
                onChange={handleHeaderColorChange}
              >
                <option value="#ff0000">Red</option>
                <option value="#00ff00">Green</option>
                <option value="#3880ff">Blue</option>
                <option value="#808080">Grey</option>
              </select>
            </div>
            <div className="form-group mt-3">
              <label htmlFor="fontColorSelect">Select Font Colour</label>
              <select
                id="fontColorSelect"
                className="form-control"
                value={fontColor}
                onChange={handleFontColorChange}
              >
                <option value="light">Dark Theme</option>
                <option value="dark">Light Theme</option>
              </select>
            </div>
            <div className="form-group mt-3">
              <label htmlFor="logoUrl">Enter Logo URL</label>
              <input
                type="text"
                id="logoUrl"
                className="form-control"
                value={logoUrl}
                onChange={handleLogoUrlChange}
              />
            </div>
            <div className="form-group mt-3">
              <label htmlFor="financialYearStart">Financial Year Start Date</label>
              <input
                id="financialYearStart"
                className="form-control"
                value={financialYearStart}
                onChange={handleFinancialYearStartChange}
              />
            </div>

            <div className="form-group mt-3">
              <label htmlFor="financialYearEnd">Financial Year End Date</label>
              <input
                id="financialYearEnd"
                className="form-control"
                value={financialYearEnd}
                onChange={handleFinancialYearEndChange}
              />
            </div>

            <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
              <button className="btn btn-primary" style={buttonStyle} onClick={saveSettings}>
                Save Settings
              </button>
              <button className="btn btn-primary" style={buttonStyle} onClick={handleStaffPricesClick}>
                Staff Prices
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default SettingsPage;
